import { onDoLogout } from '@/redux/auth';
import clearSession from '@/helpers/fetcher/session/clearSession';
import { ApiService } from './ApiService';
import { NavigationService } from './NavigationService';
import { HomePageApiService } from './HomePageApiService';
import { TokenManager } from './TokenManager';

const hasInvalidTokens = () => !TokenManager.hasValidTokens();

const getDeviceState = () => ({
  isTrustedDevice: TokenManager.getIsTrustedDevice(),
  haveTrustedDevice: TokenManager.getHaveTrustedDevice(),
  isDeviceSuspended: TokenManager.getIsDeviceSuspended(),
  pinNeedChange: TokenManager.getPinNeedChange(),
  accessToken: TokenManager.getAccessToken(),
});

export const AuthService = {
  checkAndRedirectIfNoTokens: () => {
    if (hasInvalidTokens()) {
      clearSession();
      return true;
    }
    return false;
  },

  async initializeAuth(navigate, location, dispatch) {
    if (hasInvalidTokens()) {
      dispatch(onDoLogout());
      return;
    }

    const { pinToken, isPin6Digit, hasSetPin } = await ApiService.fetchPinTokenAndData();
    const { isTrustedDevice, haveTrustedDevice, isDeviceSuspended, pinNeedChange, accessToken } =
      getDeviceState();

    NavigationService.handleNavigation(
      isTrustedDevice,
      haveTrustedDevice,
      isDeviceSuspended,
      hasSetPin,
      pinNeedChange,
      isPin6Digit,
      accessToken,
      location,
      navigate
    );

    if (pinToken && accessToken) {
      HomePageApiService.callHomePageAPIs(dispatch);
    } else {
      HomePageApiService.setupRetryMechanism(dispatch, pinToken);
    }
  },
};
